import React, { useEffect, useState, useRef } from 'react';
import Detail from '../components/ProjectDetail';
import '../styles/project.css';

export default function Project() {
  const [projects, setProjects] = useState([]);
  const [selectedType, setSelectedType] = useState('all');
  const [selectedProject, setSelectedProject] = useState(null);
  const [visibleItems, setVisibleItems] = useState({});
  const projectRefs = useRef({});

  const bucketUrl = 'https://storage.googleapis.com/ava-architects-studio/';

  useEffect(() => {
    fetch(`${bucketUrl}index.json?t=${Date.now()}`)
      .then((res) => res.json())
      .then((data) => setProjects(data))
      .catch((err) => console.error('Failed to load project index:', err));
  }, []);

  const filtered = selectedType === 'all'
    ? projects
    : projects.filter((p) => p.type === selectedType);

  // 📌 Intersection Observer setup
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const newVisible = {};
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const key = entry.target.getAttribute('data-folder');
            newVisible[key] = true;
          }
        });
        setVisibleItems((prev) => ({ ...prev, ...newVisible }));
      },
      { threshold: 0.2 }
    );

    Object.values(projectRefs.current).forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => observer.disconnect();
  }, [filtered]);

  const handleThumbnailClick = (folder) => {
    setSelectedProject(folder);
  };

  useEffect(() => {
    if (selectedProject && projectRefs.current[selectedProject]) {
      projectRefs.current[selectedProject].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
      });
    }
  }, [selectedProject]);

  const isMobile = window.innerWidth <= 768;

  return (
    <div className="project-page">
      <aside className="project-sidebar">
        <button onClick={() => setSelectedType('all')}>All</button>
        <button onClick={() => setSelectedType('Residential Architecture')}>Residential Architecture</button>
        <button onClick={() => setSelectedType('Commercial and Hospitality Architecture')}>Commercial & Hospitality</button>
        <button onClick={() => setSelectedType('Master planning &Urban design')}>Urban design& Masterplan</button>
        <button onClick={() => setSelectedType('Public and Civic Architecture')}>Public & Civil Architecture</button>
      </aside>

     <div className="project-list">
  {filtered
    .slice() // copy so we don’t mutate original
    .sort((a, b) => {
      // extract the numeric prefix from folder name
      const numA = parseInt(a.folder.match(/^\d+/)?.[0] || 0, 10);
      const numB = parseInt(b.folder.match(/^\d+/)?.[0] || 0, 10);
      return numB - numA;
    })
    .map((project) => {
      const isSelected = selectedProject === project.folder;

      // REMOVE: 2020_003_
      // REMOVE UNDERSCORES BETWEEN WORDS
      const displayName = project.folder
  .replace(/^[\d_-]+_?/, "")    // remove numeric/underscore/hyphen prefix
  .replace(/[-_]\d+/g, "")      // remove hyphen/underscore followed by numbers
  .replace(/[_-]/g, " ")      // replace remaining underscores/hyphens with space
  .trim();                      // remove extra spaces

  const sentenceCase = (str = "") =>
  str
    .trim()
    .split(" ")
    .map(word =>
      word
        .split("-")
        .map(part =>
          part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()
        )
        .join("-")
    )
    .join(" ");
      return (
        <div
          key={project.folder}
          className={`project-item ${visibleItems[project.folder] ? "visible" : ""}`}
          ref={(el) => (projectRefs.current[project.folder] = el)}
          data-folder={project.folder}
          style={{
            minHeight: isSelected ? (isMobile ? "350px" : "550px") : "auto",
          }}
        >
          {!isSelected ? (
            <div className="thumbnail-wrapper">
              <img
                src={project.thumbnail}
                alt={displayName}
                className={`project-thumbnail ${isSelected ? "clicked" : ""}`}
                onClick={() => handleThumbnailClick(project.folder)}
              />
              <p className="project-title">{sentenceCase(displayName)}</p>
              <p className="project-location">{project.location}</p>
            </div>
          ) : (
            <Detail folder={project.folder} bucketUrl={bucketUrl} />
          )}
        </div>
      );
    })}
</div>


    </div>
  );
}
